import { QueryClient } from "@tanstack/react-query";

// Shared so the auth layer can clear it: cached queries must not survive a
// login/logout boundary, or a second account on the same browser is briefly
// served the previous account's data (staleTime keeps entries warm for 60s).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    },
  },
});
